import ProgressBar from "../components/ProgressBar";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import React, { useState } from "react";
import { Mail, Phone } from "lucide-react";

function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    // Handle form submission here
    // Form data submitted successfully
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <ProgressBar />
      <TopBar />
      <div className="py-16 px-4">
        <div className="container mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold text-yellow-600 mb-2">
              Let's Talk
            </h1>
          </div>

          {/* Main Content */}
          <div className="flex flex-col lg:flex-row gap-8 max-w-7xl mx-auto">
            {/* Contact Form */}
            <div className="bg-yellow-50 rounded-2xl p-8 shadow-lg flex-1 lg:flex-[2]">
              <h2 className="text-3xl font-bold text-blue-900 mb-8">
                Get In Touch
              </h2>

              <div className="space-y-6">
                {/* Name Fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-yellow-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-yellow-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                    />
                  </div>
                </div>

                {/* Email */}
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-yellow-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                  />
                </div>

                {/* Subject */}
                <div>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-yellow-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all"
                  />
                </div>

                {/* Message */}
                <div>
                  <textarea
                    name="message"
                    placeholder="Message"
                    rows={6}
                    value={formData.message}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-yellow-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent transition-all resize-none"
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  onClick={handleSubmit}
                  className="w-full bg-yellow-600 hover:bg-yellow-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
                >
                  Send Message
                </button>
              </div>
            </div>

            {/* Contact Information */}
            <div className="space-y-6 lg:flex-1">
              {/* Mail */}
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <div className="flex items-center mb-4">
                  <Mail className="w-6 h-6 text-blue-900 mr-3" />
                  <h3 className="text-xl font-bold text-blue-900">Mail</h3>
                </div>
                <p className="text-gray-700 text-lg">salakanti@terces.io</p>
              </div>

              {/* Phone */}
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <div className="flex items-center mb-4">
                  <Phone className="w-6 h-6 text-blue-900 mr-3" />
                  <h3 className="text-xl font-bold text-blue-900">Phone</h3>
                </div>
                <p className="text-gray-700 text-lg">+919581430505</p>
              </div>

              {/* Company Info Card */}
              <div className="bg-gradient-to-br from-yellow-100 to-yellow-50 rounded-2xl p-6 shadow-lg border-2 border-yellow-200">
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-yellow-800 mb-2">
                    TERCES SOLUTIONS
                  </h3>
                  <h4 className="text-lg font-semibold text-yellow-700 mb-3">
                    PRIVATE LIMITED
                  </h4>
                  <p className="text-yellow-600 text-sm mb-4">
                    A dynamic solutions provider perfect for your business needs
                  </p>

                  <div className="flex justify-center space-x-3">
                    <button className="bg-white text-yellow-700 font-semibold py-2 px-4 rounded-lg border border-yellow-300 hover:bg-yellow-50 transition-colors duration-200 text-sm">
                      KNOW MORE
                    </button>
                    <button className="bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-yellow-700 transition-colors duration-200 text-sm">
                      GET QUOTE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footerr />
    </div>
  );
}

export default ContactUs;
